import axios from "axios";

const publicRequest = axios.create();

export function getPublicData(url: string) {
  return publicRequest.get(url);
}
